module.exports = __webpack_public_path__ + "static/img/spread2-3.69b4613.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread2-3.jpg
// module id = txKI
// module chunks = 1